// extracted by mini-css-extract-plugin
module.exports = {"box":"Dialog_box_Gu-91","content":"Dialog_content_2xI83","title":"Dialog_title_1V5mm","main":"Dialog_main_3Z2Wu"};